<template>
  <div>
    <b-login
      @success="routeForward"
      @error="error = $event"
    />
    <b-error-alert :value="!!error" :message="$t('login_error')" />
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Login",
  data: () => ({
    error: undefined,
  }),
  computed: {
    ...mapGetters("auth", {
      logged_in: "isLoggedIn",
    }),
  },
  created() {
    if (this.logged_in) {
      this.routeForward();
    }
  },
  methods: {
    routeForward() {
      this.$router.replace({name: "home", query: this.$route.query, params: this.$route.params});
    },
  },
};
</script>

<style scoped>

</style>
